"use client";
import React from "react";
import { useNavigate } from "react-router-dom";
import StatsCard from "../../../../components/stats-card";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import styles from "../css/script-menu.module.css";

const statsData = [
  { title: "Process Script", icon: "file-text" },
  { title: "Price Script", icon: "wallet" },
];

export default function ScriptMenu() { 
  const navigate = useNavigate();

const handleCardClick = (title) => {
  if (title === "Process Script") {
    navigate("/customer/dispensary/script/customer-details"); 
  } else if (title === "Price Script") {
    navigate("/customer/dispensary/price-script");  
  }
};

  return (
    <div className={styles.container}>
      <Navbar backTo="/customer/dispensary" />
      <main className={styles.main}>
        <h1 className={styles.title}>Script Menu</h1>
        <div className={styles.grid}>
          {statsData.map((stat, index) => (
            <StatsCard
              key={index}
              title={stat.title}
              icon={stat.icon}
              variant="vertical"
              onClick={() => handleCardClick(stat.title)}
            />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}